import dayjs from "dayjs";

export const earings = [
  { label: "Basic Pay", value: "basicPay" },
  { label: "House Rent Allowance (HRA)", value: "hra" },
  { label: "Conveyance", value: "conveyance" },
  { label: "Medical Allowance", value: "medicalAllowance" },
];

export const deduction = [
  { label: "Provident Fund (PF)", value: "pf" },
  { label: "Professional Tax", value: "professionalTax" },
  { label: "Income Tax", value: "incomeTax" },
];

export const monthFormat = "YYYY/MM";

export const monthIndex = {
  January: 0,
  February: 1,
  March: 2,
  April: 3,
  May: 4,
  June: 5,
  July: 6,
  August: 7,
  September: 8,
  October: 9,
  November: 10,
  December: 11,
};

export const setDetails = (payment, form, date, canEdit) => {
  const monthName = payment?.month;
  const year = payment?.year;
  const month = monthIndex?.[monthName];
  const paymentDate = canEdit
    ? month !== undefined && year
      ? dayjs().year(Number(year)).month(month).startOf("month")
      : dayjs()
    : dayjs(date);

  form.setFieldsValue({
    month: dayjs(paymentDate, "MM YYYY") || dayjs(new Date(), "MM YYYY"),
    basicPay: payment?.basicPay ?? 0,
    hra: payment?.hra ?? 0,
    conveyance: payment?.conveyance ?? 0,
    medicalAllowance: payment?.medicalAllowance ?? 0,
    pf: payment?.pf ?? 0,
    professionalTax: payment?.professionalTax ?? 0,
    incomeTax: payment?.incomeTax ?? 0,
    paymentDate: paymentDate ? dayjs(paymentDate) : null,
    isPaid: payment?.isPaid ?? false,
  });
};

const getTotal = (value, arr) => {
  const total = arr.reduce((acc, cur) => {
    return acc + value[cur.value];
  }, 0);
  return total;
};

export const payloadFormatter = (values, current) => {
  return {
    ...values,
    employeeId: current?._id,
    grossSalary: getTotal(values, earings),
    totalDeductions: getTotal(values, deduction),
    netSalary: getTotal(values, earings) - getTotal(values, deduction),
    paymentDate: values.paymentDate ? values.paymentDate.toISOString() : null,
  };
};
